export const LOADER_STATUS = 'boilderplate/GSTR6A/LOADER_STATUS';
export const HISTORY_LOADER_STATUS = 'boilderplate/GSTR6A/HISTORY_LOADER_STATUS';
export const PROFILE_INFO = 'boilerplate/GSTR6A/PROFILE_INFO';
export const VENDOR_LIST = 'boilerplate/GSTR6A/VENDOR_LIST';
export const RECO_HISTORY_DATA = 'boilerplate/GSTR6A/RECO_HISTORY_DATA';
export const HISTORY_TABLE_TOTAL_PAGES = 'boilerplate/GSTR6A/HISTORY_TABLE_TOTAL_PAGES';
export const SAVE_RECO_HISTORY_TABLE_PAGES = 'boilerplate/GSTR6A/SAVE_RECO_HISTORY_TABLE_PAGES';
export const SET_DOCUMENTVIEW_TABLE_PAGES = 'boilerplate/GSTR6A/SET_DOCUMENTVIEW_TABLE_PAGES';
export const SET_DOCUMENTVIEW_CURRENT_PAGE = 'boilerplate/GSTR6A/SET_DOCUMENTVIEW_CURRENT_PAGE';
export const REFRESH_TAB = 'boilerplate/GSTR6A/REFRESH_TAB';


export const DocTypeArr =  [ "B2B", "B2BA", "CDN", "CDNA", "0"];
export const DocType = [
    {
    label: "All",
    value: "All",
    tagClassName: "special",
    checked: true,
    children: [
      {
        label: "B2B",
        value: "B2B",
      },
      {
        label: "B2BA",
        value: "B2BA",
      },
      {
        label: "CDN",
        value: "CDN",
      },
      {
        label: "CDNA",
        value: "CDNA",
      },
    ]
    }
];
export const OriginalMatchTypeArr = ["EXACT MATCH", "PROBABLE MATCH" , "MISMATCH", "MISSING IN GSTR6A", "MISSING IN DATA"];
export const OriginalMatchType = [
    {
    label: "All",
    value: "All",
    tagClassName: "special",
    checked: true,
    children: [
      {
        label: "EXACT MATCH",
        value: "EXACT MATCH",
      },
      {
        label: "PROBABLE MATCH",
        value: "PROBABLE MATCH",
      },
      {
        label: "MISMATCH",
        value: "MISMATCH",
      },
      {
        label: "MISSING IN GSTR6A",
        value: "MISSING IN GSTR6A",
      },
      {
        label: "MISSING IN DATA",
        value: "MISSING IN DATA",
      },
    ]
    }
];
export const RevisedMatchTypeArr = ["FORCE MATCH", "null"];
export const RevisedMatchType = [
    {
    label: "All",
    value: "All",
    tagClassName: "special",
    checked: true,
    children: [
      {
        label: "Force Match",
        value: "FORCE MATCH",
      },
      {
        label: "No Action Taken",
        value: "null",
      },
    ]
    }
];